import { render, staticRenderFns } from "./componentEmpty.vue?vue&type=template&id=cd638f40&scoped=true"
import script from "./componentEmpty.vue?vue&type=script&lang=js"
export * from "./componentEmpty.vue?vue&type=script&lang=js"
import style0 from "./componentEmpty.vue?vue&type=style&index=0&id=cd638f40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd638f40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd638f40')) {
      api.createRecord('cd638f40', component.options)
    } else {
      api.reload('cd638f40', component.options)
    }
    module.hot.accept("./componentEmpty.vue?vue&type=template&id=cd638f40&scoped=true", function () {
      api.rerender('cd638f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/componentEmpty.vue"
export default component.exports